import { createSelector } from 'reselect';

const baseSelector = (state) => state.base;

export const selectOrganisation = createSelector(
  [baseSelector],
  (base) => base.organisation
);
